module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-cen"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_vm._v("If you love "), _c('span', {
    staticClass: "txbfit"
  }, [_vm._v("The Magnificent Mrs. Mayhew")]), _vm._v(", discover Milly Johnson’s other books, available in paperback and ebook now.")])]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('p', {
    staticClass: "fm-cen1"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("The Yorkshire Pudding Club")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-noind"
  }, [_vm._v("Three friends become pregnant at the same time. For Helen, it’s a dream come true. For Janey, the timing couldn’t be worse. Elizabeth doubts if she can care for a child. But soon the women find themselves empowered by unexpected pregnancy.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-cen1"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("The Birds and the Bees")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-noind"
  }, [_vm._v("Romance writer and single mum Stevie Honeywell has only weeks to go until her wedding when her fiancé, Matthew, runs off with her glamorous new friend Jo. It feels like history repeating itself for Stevie, but this time she is determined to win back her man.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-cen1"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("A Spring Affair")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-noind"
  }, [_vm._v("“Clear your house and clear your mind. Don’t let life’s clutter dictate to you. Throw it away and take back control!” When Lou Winter picks up a dog-eared magazine in the dentist’s waiting room and spots an article about clearing clutter, she little realizes how it will change her life . . .")]), _vm._v(" "), _c('p', {
    staticClass: "fm-cen1"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("A Summer Fling")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-noind"
  }, [_vm._v("When dynamic, power-dressing Christie blows in like a warm wind to take over at work, five very different women find themselves thrown together. But none of them could have predicted the fierce bond of friendship that her leadership would inspire . . .")]), _vm._v(" "), _c('p', {
    staticClass: "fm-cen1"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Here Come the Girls")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-noind"
  }, [_vm._v("Ven, Roz, Olive, and Frankie have been friends since school. They daydreamed of glorious futures, full of riches, romance, and fabulous jobs. Twenty-five years later, things are not as they imagined. But that doesn’t mean they have given up.")])]), _c('p', {
    staticClass: "fm-cen1"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("An Autumn Crush")])])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "fm-noind"
  }, [_vm._v("Four friends, two crushes, and a secret . . . After a bruising divorce, Juliet Miller invests in a flat and advertises for a flatmate. Along comes self-employed copywriter Floz, raw from her own relationship split, and the two women hit it off. Will they help each other to find new romance?")]), _vm._v(" "), _c('p', {
    staticClass: "fm-cen1"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("White Wedding")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-noind"
  }, [_vm._v("Bel, Violet, and Max befriend each other at the White Wedding bridal shop as they prepare for their trips down the aisle. But is love the primary reason that these three women are getting married?")]), _vm._v(" "), _c('p', {
    staticClass: "fm-cen1"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("A Winter Flame")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-noind"
  }, [_vm._v("Eve has never liked Christmas. So when her adored elderly aunt dies, the last thing she is expecting is to be left a theme park in her will. Can she overcome her dislike of Christmas, and can her difficult counterpart Jacques melt her frozen heart at last?")]), _vm._v(" "), _c('p', {
    staticClass: "fm-cen1"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("It’s Raining Men")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-noind"
  }, [_vm._v("Best friends from work May, Lara, and Clare are desperate for some time away. So they set off to a luxurious spa for ten glorious days. But when they arrive at their destination, it’s not quite the place they thought it was . . .")]), _vm._v(" "), _c('p', {
    staticClass: "fm-cen1"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("The Teashop on the Corner")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-noind"
  }, [_vm._v("Spring Hill Square is a pretty sanctuary away from the bustle of everyday life. And at its center is Leni Merryman’s Teashop on the Corner. Can friends Carla, Molly, and Will find the comfort they are looking for there?")]), _vm._v(" "), _c('p', {
    staticClass: "fm-cen1"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Afternoon Tea at the Sunflower Café")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-noind"
  }, [_vm._v("When Connie discovers that Jimmy, her husband of more than twenty years, is planning to leave her for his office junior, her world is turned upside down. Determined to salvage her pride, she plots her revenge.")])]), _c('p', {
    staticClass: "fm-cen1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Sunshine Over Wildflower Cottage")])])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('p', {
    staticClass: "fm-noind"
  }, [_vm._v("New beginnings, old secrets, and a place to call home—escape to Wildflower Cottage with Viv, Geraldine, and Stel for love, laughter, and friendship.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-cen1"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("The Queen of Wishful Thinking")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-noind"
  }, [_vm._v("Lewis Harley has opened the antiques shop he always dreamed of. When Bonnie Brookland walks into Lew’s shop, she knows this is the place for her. But each has secrets in their past that are about to be uncovered. Can they find the happiness they both deserve?")]), _vm._v(" "), _c('p', {
    staticClass: "fm-cen1"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("The Perfectly Imperfect Woman")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-noind"
  }, [_vm._v("Marnie has made so many mistakes in her life that she fears she will never get on the right track. But when Lilian, an eccentric old lady from a baking chatroom, offers her a fresh start, she packs up and heads for Wychwell. But her arrival is as unpopular as a force 12 gale in a confetti factory . . . Will this little village in the heart of the Yorkshire Dales accept her as one of their own?")]), _vm._v(" "), _c('p', {
    staticClass: "fm-cen1"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("The Mother of All Christmases")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-noindb"
  }, [_vm._v("Annie, Palma, and Eve all meet at the “Christmas Pudding Club,” a new group started by a forward-thinking young doctor to help mums-to-be mingle and share their pregnancy journeys. Will this group help them to find love, contentment, and peace as Christmas approaches?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e26bbbf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/praise.vue
// module id = 57
// module chunks = 0